import { patchGroup } from 'common/api/v1/segments';

import {
    CHANGE_MODULE_STATUS,
    CHANGE_MODULE_STATUS_FAILURE,
    CHANGE_MODULE_STATUS_SUCCESS,
} from '../actionTypes';
import { panelLayoutV2Actions } from '../reducer';

export default (segmentUUID, groups, asce_metadata) => (dispatch) => {
    dispatch(panelLayoutV2Actions[CHANGE_MODULE_STATUS]());

    patchGroup(segmentUUID, { asce_metadata, groups })
        .then((response) => {
            dispatch(
                panelLayoutV2Actions[CHANGE_MODULE_STATUS_SUCCESS](response),
            );
        })
        .catch((error) => {
            dispatch(panelLayoutV2Actions[CHANGE_MODULE_STATUS_FAILURE](error));
        });
};
